<div class="w-12">
    @for (attribute of attributes; track $index) {
    @if (attribute.code == 'giftcard_occasion' && attribute.options?.length > 1) {
    <div>
        <p class="p1 m-b-2 flex flex-middle"
           [class.wrap]="wrapElements">@if(havePersonaliseOccasion) {
            {{'1. Choose or' | translate}}&nbsp;<button class="underline inline-flex cursor-pointer"
                    (click)="pick('giftcard_occasion', this.personaliseOccasionAttrOption)">{{'upload your own design' |
                translate}}</button>
            } @else {
            {{'1. Choose' | translate}}
            }
        </p>
        <div class="bg-col-4 p-t _carouselOptions overflow-hidden">
            <carousel [scrollbar]="{draggable: true}"
                      [slidesPerView]="'auto'"
                      [freeMode]="true"
                      [class.wrap]="wrapElements"
                      class="overflow-visible">
                @for (option of attribute.options; track option; let isLast = $last) {
                @if (option.product) {
                <ng-template swiperSlide>
                    <button type="button"
                            class="ratio-3-2 w-12 overflow-hidden"
                            style="border-radius: 5px; box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.15);"
                            (click)="pick(attribute, option)">
                        <shell></shell>
                        <img class="rf"
                             [image]="option.product.data.image" />
                    </button>

                    <p class="m-t-1 p2">
                        {{option.label | translate}}</p>
                </ng-template>
                }
                }
            </carousel>
        </div>
    </div>
    }
    }
    @if(isPersonaliseOccasionSelected) {
    <input-wrap class="ng-hide">
        <input type="text"
               [(ngModel)]="request.file"
               name="file"
               [required]="true" />
    </input-wrap>
    @if(displayCustomFieldInputError) {
    <p class="col-2 p3 m-t-2">{{'Please select image' | translate}}</p>
    }
    }
</div>